import { useRef } from "react";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Icon,
  Stack,
  Text,
} from "@chakra-ui/react";
import { FaCheckCircle } from "react-icons/fa";
import { useTranslation } from "react-i18next";

interface CompletedInsteadDialogProps {
  isOpen: boolean;
  onAcknowledge: () => void;
}

export const CompletedInsteadDialog = ({
  isOpen,
  onAcknowledge,
}: CompletedInsteadDialogProps) => {
  const { t } = useTranslation();
  const focusRef = useRef<HTMLButtonElement>(null);

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={focusRef}
      onClose={onAcknowledge}
      closeOnOverlayClick={false}
      closeOnEsc={false}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            <Stack direction="row" align="center" spacing="3">
              <Icon as={FaCheckCircle} color="smPrimary" boxSize="5" />
              <Text>{t("Signing already completed")}</Text>
            </Stack>
          </AlertDialogHeader>
          <AlertDialogBody>
            <Text>{t("Completed instead description line one")}</Text>
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button
              ref={focusRef}
              colorScheme="teal"
              onClick={onAcknowledge}
            >
              {t("OK")}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};
